var slickProperties;

var zoom = {

	container: $('.zoom-container'),
	tooltip: $('.zoom-tooltip'),
	zoomedEl: $('.zoom-large'),
	closeEl: $('.zoom-close'),

	// Make things follow the mouse
	followMouse: {

		tooltip: function() {
			$('.zoom-container').on('mousemove', function(e){
			    $(this).find('.zoom-tooltip').offset({
			    	left: e.pageX + 12,
			    	top: e.pageY - 22
			    });
			});
		},

		// Zoom and pan functionality
		zoomedImg: function(zoomWrapper, resize) {

			// Define elements
			zoomWrapper = zoomWrapper.find('.zoom-img-container');
			var zoomImg = zoomWrapper.find('.zoom-img');

			// get container's dimensions
			var conWidth = zoomWrapper.width();
			var conHeight = zoomWrapper.height();
			// get image's dimensions
			var imgWidth = zoomImg.width();
			var imgHeight = zoomImg.height();

			// Get the smallest size possible to fit container
			var smallestImg;
			if (conWidth >= conHeight) {
				smallestImg = conHeight / imgHeight;
			} else {
				smallestImg = conWidth / imgWidth;
			}

			var disableZoomPan = false;
			if (smallestImg > 0.7) {
				zoomWrapper.find('.zoom-pinch').addClass('hide');
				// Apply panzoom plugin
				zoomImg.panzoom({
					contain: 'invert',
					minScale: smallestImg,
		  			maxScale: smallestImg,
		  			disablePan: true,
				}).panzoom('zoom', smallestImg, {silent: true});
			} else {

				zoomWrapper.find('.zoom-pinch').removeClass('hide');
				// Apply panzoom plugin
				zoomImg.panzoom({
					contain: 'invert',
					minScale: smallestImg,
		  			maxScale: 1,
		  			increment: 0.3,
		  			scale: true
				}).panzoom('zoom', smallestImg, {silent: true});
			}

			if (!resize) {
				zoomImg.css('display', 'block').hide().fadeIn();
			}

			var $panzoom = zoomImg.panzoom();
			$panzoom.on('mousewheel.focal', function( e ) {
				e.preventDefault();
				var delta = e.delta || e.originalEvent.wheelDelta;
				var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
				$panzoom.panzoom('zoom', zoomOut, {
					increment: 0.1,
					focal: e
				});
			});
		}
	},

	// Show/hide tooltip
	showTooltip: function() {
		// Apply tooltip and zoom for non-touch devices
		$('.zoom-container').hover(
			// Show tooltip on mouse enter
			function() {
				var _this = $(this);
				if (!_this.hasClass('overlay-open')) {
					_this.addClass('zoom-container-hover');
					// Apply tooltip functionality
					zoom.followMouse.tooltip();

					// Get product elements that shouldn't be clickable for zoom functionality
					var overlayEl = _this.find('.product-overlay'),
						overlayEl_content = _this.find('.product-overlay *')
						overlay_open = _this.find('.product-overlay-open'),
						overlay_close = _this.find('.product-overlay-close'),
						overlay_zoom = _this.find('.zoom-large');
					var innerDisableEls;
					if (_this.closest('.small-product-carousel').length) {
						innerDisableEls = overlayEl.add(overlayEl_content).add(overlay_open).add(overlay_close).add(overlay_zoom).add('.small-product-carousel-copy').add('.small-product-carousel-copy *').add(_this);
					} else {
						innerDisableEls = overlayEl.add(overlayEl_content).add(overlay_open).add(overlay_close).add(overlay_zoom);
					}
					var moving = false;
					/*
					_this.on('mousemove', function(){
						//console.log( "zoom: mousemove" );
						moving = true;
					});
					*/
					_this.on('mousedown', function(){
						moving = false;
					});

					// Listent to click event on zoomable products
					_this.on('mouseup', function(e){
						//console.log( "zoom: mouseup" );
						e.preventDefault();
						//console.info( "zoom: mouseup: moving:", moving );
						if (!moving) {
							// Prevent zoom when clicking on certain elements
							//console.info( !$(e.target).is(innerDisableEls) );
							//console.info( !$(e.target).is('.product-overlay *') );
							//console.info( !$(e.target).is('.zoom-large *') );


							if (!$(e.target).is(innerDisableEls) && !$(e.target).is('.product-overlay *') && !$(e.target).is('.zoom-large *')) {
								scrollPos = $('html,body').scrollTop();
								// Show zoom container
								zoom.zoomedEl_show(_this);

								// Lazy load selected product's big image
								var imageEl = _this.find('.zoom-img');
								zoom.lazyload(imageEl);
								// image loading latency test
								// setTimeout(function(){
								// 	zoom.lazyload(imageEl);
								// },2000);

								// Once image is loaded, show it and apply pan functionality to zoomed image
								if (_this.find('.zoom-loaded').length) {
									_this.find('.zoom-img').css('display', 'block');
									if (isTouch) {
										setTimeout(function(){
											zoom.followMouse.zoomedImg(_this.find('.zoom-large'));
										},250);
									}
								} else {
									imageEl.load(function(){
										_this.find('.zoom-large').addClass('zoom-loaded');
										_this.find('.zoom-img').css('display', 'block').hide().fadeIn();
										if (isTouch) {
											setTimeout(function(){
												zoom.followMouse.zoomedImg(_this.find('.zoom-large'));
											},250);
										}
									});
								}
							}
							moving = false;
						}
					});
					// Hide xoom toltip when hover over other clickable elements
					_this.find(innerDisableEls).hover(
						// hide tooltip
						function() {
							$(this).closest('.zoom-container').addClass('zoom-container-hoverDisable');
						},
						// Show tooltip
						function() {
							$(this).closest('.zoom-container').removeClass('zoom-container-hoverDisable');
						}
					);
				}
			},
			// hide tooltip on mouse out
			function() {
				if (!$(this).hasClass('overlay-open')) {
					$(this).removeClass('zoom-container-hover');
				}
			}
		);

		$('.zoom-container').find('.zoom-close').click(function(e){
			e.preventDefault();
			zoom.zoomedEl_hide();
		});
	},

	// Add an element(s) to the zoom variable(s)
	add: function( el ) {
		//console.log( "zoom: add" );

		zoom.container = zoom.container.add( el );
		zoom.tooltip = zoom.tooltip.add( el.find( '.zoom-tooltip' ) );
		zoom.zoomedEl = zoom.zoomedEl.add( el.find( '.zoom-large' ) );
		zoom.closeEl = zoom.closeEl.add( el.find( '.zoom-close' ) );

	},

	zoomSetup: function() {
		//console.log( "zoom: zoomSetup" );

		// Define elements
		var targetEl = $('.zoom-container');
		// Get product elements that shouldn't be clickable for zoom functionality
		var overlayEl = targetEl.find('.product-overlay'),
			overlayEl_content = targetEl.find('.product-overlay *')
			overlay_open = targetEl.find('.product-overlay-open'),
			overlay_close = targetEl.find('.product-overlay-close'),
			overlay_zoom = targetEl.find('.zoom-large');
		var innerDisableEls = overlayEl.add(overlayEl_content).add(overlay_open).add(overlay_close).add(overlay_zoom);


		var moving = false;
		targetEl.on('mousemove', function(e){
			moving = true;
		});
		targetEl.on('mousedown', function(e){
		    moving = false;		  
		});

		targetEl.on('mouseup', function(e){
			e.preventDefault();
			if (!moving) {
				// Define elements
				var _this = $(this);
				var imageEl = _this.find('.zoom-img');
				// Prevent zoom when clicking on certain elements
				if (!$(e.target).is(innerDisableEls) && !$(e.target).is('.product-overlay *') && !$(e.target).is('.zoom-large *')) {
					scrollPos = $('body').scrollTop();
					// Show zoom container
					zoom.zoomedEl_show(_this);

					// Check if image has been loaded or not and act consequently
					if (_this.find('.zoom-loaded').length) {
						if (isTouch) {
							zoom.resetPanZoom(_this.find('.zoom-loaded'));
						}
					} else {
						// Lazy load selected product's big image
						zoom.lazyload(imageEl);
						// image loading latency test
						// setTimeout(function(){
						// 	zoom.lazyload(imageEl);
						// },2000);

						// Once image is loaded, show it and apply pan functionality to zoomed image
						imageEl.load(function(){
							_this.find('.zoom-large').addClass('zoom-loaded');
							if (isTouch) {
								setTimeout(function(){
									zoom.followMouse.zoomedImg(_this.find('.zoom-large'));
								},250);
							}
						});
					}
				}
				moving = false;
			}
		});

		// Hide zoom container when click on close
		targetEl.find('.zoom-close').click(function(e){
			e.preventDefault();
			zoom.zoomedEl_hide();
		});
	},

	// Simply unbinds events prepping for new items to be added.
	destroy: function() {
		//console.log( "zoom: destroy" );

		$( '.zoom-close' ).off( 'click mousedown mouseenter mouseleave mousemove mouseup' );
		$( '.zoom-container' ).off( 'click mousedown mouseenter mouseleave mousemove mouseup' );

	},

	// Open/close zoom overlay
	zoomedEl_show: function(mainContainer) {
		mainContainer.find('.zoom-large').addClass('zoom-open');
		// Prevent scroll when modal shown
		var parentCarousel = mainContainer.closest('.slick-track');
		if (!isTouch && parentCarousel.length) {
			// slickProperties = parentCarousel.attr('style');
			parentCarousel.addClass('slider-zoom-open');
		}
		if ($('.zoom-open').closest('.slider-hero-content').length) {
			$('.slider-hero-content').find('.slick-track').addClass('slider-zoom-open');
		}
	},

	// Close zoom conainer event
	zoomedEl_hide: function() {
		var parentCarousel = $('.zoom-open').closest('.slick-track');
		if (!isTouch && parentCarousel.length) {
			parentCarousel.removeClass('slider-zoom-open');
			// parentCarousel.attr('style', slickProperties);
		}
		if ($('.zoom-open').closest('.slider-hero-content').length) {
			$('.slider-hero-content').find('.slick-track').removeClass('slider-zoom-open');
		}
		$('#product-zoom-image').closest('.zoom-large').removeClass('zoom-loaded');
		$('.zoom-open').removeClass('zoom-open');
		$('#product-zoom-image').removeAttr('style');
		/*setTimeout(function(){
			$('body').scrollTop( scrollPos );
			scrollPos = null;
		},100);*/
	},

	// Load zoomable image
	lazyload: function(targetEl) {
		var img_url = targetEl.attr('data-img-zoom');
		targetEl.attr('src', img_url);
	},

	// Reset any existing panzoom on window resize
	resetPanZoom: function(targetEl) {
		//console.log('resetPanZoom::')
		var _this = targetEl;
		var imageEl = _this.find('.zoom-img');
		imageEl.panzoom('resetZoom');
		imageEl.panzoom('resetPan');
		imageEl.panzoom('resetDimensions');
		imageEl.panzoom('destroy');
		setTimeout(function(){
			//console.log('zoom.followMouse.zoomedImg::')
			zoom.followMouse.zoomedImg(_this.closest('.zoom-large'));
		},500);
	},

	// Initialise zoom functionality
	init: function() {
		//console.log( "zoom: init" );

		if ($('.zoom-container').length) {
			if (!isTouch) {
				// Zoom and pan functionality for non-touch devices
				zoom.showTooltip();
				//console.log( "not touch" );
				$(document).on('keyup', function(e){
			    e = e || window.event;
			    if ($('.zoom-open').length){
			    	e.stopImmediatePropagation(); // prevent other elements (eg some modal undereath) from firing 'keyup'
			    }
			    if (e.keyCode == 27) {
				   	zoom.zoomedEl_hide();
			    }
				});

			} else {
				// Zoom and pan functionality for touch devices
				//console.log('calling zoom.zoomSetup isTouch')
				zoom.zoomSetup();
			}
			// Close zoom conainer event
			zoom.zoomedEl_hide();
		}
	}
};